import { combineReducers } from 'redux'
import { handleActions } from 'redux-actions'

import { defaultInfo, defaultInternalLinks, defaultBreadcrumbs, defaultSeoContent } from './defaultState'

export const info = handleActions({}, defaultInfo)
export const internalLinks = handleActions({}, defaultInternalLinks)
export const breadcrumbs = handleActions({}, defaultBreadcrumbs)
export const seoContent = handleActions({}, defaultSeoContent)

export default combineReducers({
  info,
  internalLinks,
  breadcrumbs,
  seoContent
})
